import { render, staticRenderFns } from "./PosterSetUp.vue?vue&type=template&id=10d40f4a&"
import script from "./PosterSetUp.vue?vue&type=script&lang=js&"
export * from "./PosterSetUp.vue?vue&type=script&lang=js&"
import style0 from "./PosterSetUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports